<template>
  <div class="GlobalTable">
    <div>
      <!-- <div class="line"></div> -->
      <div class="module-title">
        启用限时红包
        <el-switch v-model="useRewardLimit" style="margin-left: 20px"></el-switch>
      </div>
      <div class="mb-10">
        <div class="module-title">限时红包时效设置</div>
        <div class="flex mb-10">
          <img
            src="@/assets/images/ico_ts_red.png"
            style="margin-right: 8px"
            alt=""
          />
          <span class="tip-color"
            >说明：倒计时仅用作小程序展示，若倒计时结束后会重新开始计时。</span
          >
        </div>
        <div class="mb-10">
          <span style="font-size: 14px; color: #333333"
            >限时加价红包时效(小时)：</span
          >
          <el-select v-model="rewardExpire" size="mini" placeholder="请选择">
            <el-option
              v-for="item in timeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line"></div>
      <div class="module-title">
        限时红包规则
        <el-button
          type="text"
          style="padding:0;text-decoration: underline;margin-left:20px"
          @click="seeImg"
          >查看限时红包示例</el-button
        >
      </div>
      <!-- <div class="set-title flex">商户估价系数设置</div>
      <div class="flex mb-10">
        <img
          src="@/assets/images/ico_ts_red.png"
          style="margin-right: 8px"
          alt=""
        />
        <span class="tip-color"
          >说明：商户默认使用系统估价，各商户可根据合作回收商报价高低与系统报价进行对比，若系统出价相对于回收商价格较高，可适当调低。若线上回收运营需使用较高预估价吸引顾客到店，系数可设置大于1，提前向店员培训相关的话术以免造成误解。</span
        >
      </div>
      <div class="flex mb-10">
        <span style="font-size:15px;color:#333">商户估价 = 系统估价 × </span>
        <el-input
          class="factor-rate"
          v-model.trim="factorRate"
          @input="limitInput($event, 'factorRate', 'this')"
          size="mini"
        ></el-input>
      </div>
      <div class="line"></div> -->
      <div class="set-title flex">限时红包计算</div>
      <div class="flex mb-10" style="font-size:15px;color:#333">
        1. 限时红包 + 本机估价 = 用户估价
      </div>
      <!-- <div class="mb-10">
        <div class="mb-10" style="font-size:15px;color:#333">
          2. 用户估价设置
        </div>
        <el-radio-group v-model="usePayConfig">
          <el-radio :label="true"
            >用户估价=商户估价-回收业务已设置的利润红包</el-radio
          >
          <el-radio :label="false">用户估价=商户估价</el-radio>
        </el-radio-group>
      </div> -->
      <!-- <div class="line"></div> -->
      <div class="set-title flex">
        <div>限时红包规则</div>
        <!-- <el-button
          type="text"
          style="padding:0;text-decoration: underline;margin-left:20px"
          @click="seeProfit"
          >查看公司利润设置</el-button
        > -->
      </div>
      <div class="flex flex-jb mb-10">
        <div class="flex">
          <img src="@/assets/images/ico_ts_red.png" style="margin-right: 8px"/>
          <span class="tip-color">说明：设置的显示红包比例为小程序用户预估价的占比比例。</span>
        </div>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addRule('profit')"
          >添加规则</el-button
        >
      </div>
      <GlobalTable
        ref="GlobalTable"
        myKey="redPacket"
        :columns="packetColumns"
        :isPagination="false"
        :data="regionDtoList"
      >
        <el-table-column label="用户估价价位段" slot="rank" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lower }}＜区间≤{{ row.upper }}</span>
          </template>
        </el-table-column>
        <el-table-column label="限时红包比例" slot="reward" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.reward }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          label="本机估价（默认）"
          slot="shopownerCutPriceLimit"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{formatNum(100,row.reward,'-',2)}}%</span>
          </template>
        </el-table-column>
        <el-table-column label="限时红包上限" slot="rewardLimit" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.rewardLimit }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :label-width="'200px'"
          slot="operation"
          align="center"
        >
          <template slot-scope="{ row, $index }">
            <el-button
              size="mini"
              type="primary"
              round
              @click="configBtn(row, 'edit', $index)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              round
              @click="configBtn(row, 'del', $index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </GlobalTable>
      <!-- <div class="mt-10">
        <el-button :loading="btnLoading" type="primary" @click="save(false)">提交次日生效</el-button>
        <el-button :loading="btnLoading" type="warning" @click="save(true)">提交立即生效</el-button>
      </div> -->
      <!-- <div class="mt-10">
        <el-button type="primary" @click="confirmBtn">提交</el-button>
      </div> -->
      <el-dialog
        title="添加规则"
        :visible.sync="dialogRuleVisible"
        :close-on-click-modal="false"
        width="400px"
        @closed="ruleDialogClosed"
      >
        <div class="rules-form">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="96px"
            class="demo-ruleForm"
          >
            <el-form-item label="估价价位段:" required>
              <el-col :span="11">
                <el-form-item prop="lower">
                  <el-input
                    size="small"
                    v-model.trim="ruleForm.lower"
                    oninput="this.value=value.replace(/[^0-9]/g,'')"
                    placeholder="输入起始值"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col style="text-align: center" :span="2">~</el-col>
              <el-col :span="11">
                <el-form-item prop="upper">
                  <el-input
                    size="small"
                    v-model.trim="ruleForm.upper"
                    oninput="this.value=value.replace(/[^0-9]/g,'')"
                    placeholder="输入结束值"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="红包比例:" prop="reward">
              <el-input
                size="small"
                placeholder="输入红包比例"
                v-model="ruleForm.reward"
                @input="limitInput($event, 'reward', 'ruleForm')"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="红包上限:" prop="rewardLimit">
              <el-input
                size="small"
                v-model.trim="ruleForm.rewardLimit"
                oninput="this.value=value.replace(/[^0-9]/g,'')"
                placeholder="输入红包上限金额"
                maxlength="5"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click.native="dialogRuleVisible = false">取消</el-button>
          <el-button type="primary" @click.native="handleSuccess"
            >确定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="删除确认"
        :visible.sync="dialogDelVisible"
        :close-on-click-modal="false"
        width="380px"
      >
        <div class="del-title">
          <div class="sure_tip">确认要删除该数据吗？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click.native="dialogDelVisible = false">取消</el-button>
          <el-button type="primary" @click.native="handleSuccessDel"
            >确定</el-button
          >
        </span>
      </el-dialog>
      <!-- <el-dialog
        title="保存提示"
        :visible.sync="dialogSubmitVisible"
        :close-on-click-modal="false"
        width="380px"
      >
        <div class="del-title">
          <div class="sure_tip">确认要保存本次设置吗？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click.native="dialogSubmitVisible = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            :loading="btnLoading"
            @click.native="handleSuccessSave"
            >确定</el-button
          >
        </span>
      </el-dialog> -->
      <!-- <el-dialog
        title="公司回收利润及员工红包设置"
        :visible.sync="dialogProfitVisible"
        :close-on-click-modal="false"
        width="800px"
        @close="radioProfit = '01'"
      >
        <div class="mb-20">
          <el-radio-group v-model="radioProfit">
            <el-radio-button label="01">公司利润</el-radio-button>
            <el-radio-button label="02">员工红包</el-radio-button>
          </el-radio-group>
        </div>
        <GlobalTable
          v-if="radioProfit == '01'"
          ref="GlobalTable"
          myKey="radioProfit01"
          :columns="rebateColumns"
          :data="
            rebateRegionList.slice(
              (rebatePage.pageNum - 1) * rebatePage.pageSize,
              rebatePage.pageNum * rebatePage.pageSize
            )
          "
          :currentPage="rebatePage.pageNum"
          :total="rebateRegionList.length"
          :pageSize="rebatePage.pageSize"
          @handleCurrentChange="rebateHandleCurrentChange"
        >
          <el-table-column label="报价区间" slot="rank" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
            </template>
          </el-table-column>
          <el-table-column label="门店返利" slot="rebate" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.rebate }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            label="门店返利上限"
            slot="rebateLimit"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>￥{{ row.rebateLimit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="预留返利" slot="delayRebate" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.delayRebate }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            label="预留返利上限"
            slot="delayRebateLimit"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>￥{{ row.delayRebateLimit }}</span>
            </template>
          </el-table-column>
        </GlobalTable>
        <GlobalTable
          v-if="radioProfit == '02'"
          ref="GlobalTable"
          myKey="radioProfit02"
          :columns="redPacketColumns"
          :data="
            apRegionList.slice(
              (redPacketPage.pageNum - 1) * redPacketPage.pageSize,
              redPacketPage.pageNum * redPacketPage.pageSize
            )
          "
          :currentPage="redPacketPage.pageNum"
          :total="apRegionList.length"
          :pageSize="redPacketPage.pageSize"
          @handleCurrentChange="redHandleCurrentChange"
        >
          <el-table-column label="报价区间" slot="rank" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="店长红包"
            slot="shopownerReward"
            align="center"
          >
            <template slot-scope="{ row }">
              <span
                >{{ row.rebateType == "02" ? "￥" : "" }}{{ row.shopownerReward
                }}{{ row.rebateType == "01" ? "%" : "" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="店长红包上限"
            slot="shopownerRewardLimit"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>￥{{ row.shopownerRewardLimit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="店员红包" slot="clerkReward" align="center">
            <template slot-scope="{ row }">
              <span
                >{{ row.rebateType == "02" ? "￥" : "" }}{{ row.clerkReward
                }}{{ row.rebateType == "01" ? "%" : "" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="店员红包上限"
            slot="clerkRewardLimit"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>￥{{ row.clerkRewardLimit }}</span>
            </template>
          </el-table-column>
        </GlobalTable>
      </el-dialog> -->
      <el-image-viewer
        v-if="showViewer"
        :on-close="
          () => {
            showViewer = false;
          }
        "
        :url-list="imgList"
      />
    </div>
  </div>
</template>

<script>
import _api from "@/utils/request";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  name: "Table",
  components: { ElImageViewer },
  props: {
    config: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      dialogRuleVisible: false,
      dialogDelVisible: false,
      dialogSubmitVisible: false,
      dialogProfitVisible: false,
      showViewer: false,
      imgList:['https://img.fanxinghuishou.cn/20230814/335273672.png'],
      rewardExpire: "24",
      factorRate: "1",
      usePayConfig: true,
      btnLoading: false,
      packetColumns: [
        { slotName: "rank" },
        { slotName: "reward" },
        { slotName: "shopownerCutPriceLimit" },
        { slotName: "rewardLimit" },
        { slotName: "operation" },
      ],
      regionDtoList: [],
      rowId: "",
      ruleForm: {
        lower: "",
        upper: "",
        reward: "",
        rewardLimit: "",
      },
      rules: {
        lower: [{ required: true, message: "请输入起始值", trigger: "blur" }],
        upper: [{ required: true, message: "请输入结束值", trigger: "blur" }],
        reward: [
          { required: true, message: "请输入红包比例", trigger: "blur" },
        ],
        rewardLimit: [
          { required: true, message: "输入红包上限金额", trigger: "blur" },
        ],
      },
      timeOptions: [
        {
          value: "24",
          label: "24(1天)",
        },
        {
          value: "48",
          label: "48(2天)",
        },
        {
          value: "72",
          label: "72(3天)",
        },
        {
          value: "96",
          label: "96(4天)",
        },
        {
          value: "120",
          label: "120(5天)",
        },
      ],
      radioProfit: "01",
      rebateRegionList: [],
      apRegionList: [],
      rebatePage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      redPacketPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      rebateColumns: [
        { slotName: "rank" },
        { slotName: "rebate" },
        { slotName: "rebateLimit" },
        { slotName: "delayRebate" },
        { slotName: "delayRebateLimit" },
      ],
      redPacketColumns: [
        { slotName: "rank" },
        { slotName: "shopownerReward" },
        { slotName: "shopownerRewardLimit" },
        { slotName: "clerkReward" },
        { slotName: "clerkRewardLimit" },
      ],
      useRewardLimit: false
    };
  },
  watch: {
    config: {
      handler(v) {
        if (v) {
          this.rewardExpire = v.rewardExpire + "";
          this.regionDtoList = v.regionDtoList || [];
          this.useRewardLimit = v.useRewardLimit
          // this.factorRate = v.factorRate
          // this.usePayConfig = v.usePayConfig
          // this.showPriceType = v.showPriceType
          // this.userPriceShowRegionList = v.userPriceShowRegionList || []
        }
      },
      immediate: true
    }
  },
  created() {
    // this.getPayconfig();
    // this.configInfo();
  },
  methods: {
    // 获取平台支付配置详情
    configInfo() {
      _api.configInfo().then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.rebateRegionList = res.data.rebateRegionList;
          this.apRegionList = res.data.apRegionList;
        }
      });
    },
    // 获取配置详情
    // getPayconfig() {
    //   _api.getPayconfig().then((res) => {
    //     if (res.code == 1) {
    //       if (res.data) {
    //         this.factorRate = res.data.factorRate;
    //         this.rewardExpire = res.data.rewardExpire + "";
    //         this.usePayConfig = res.data.usePayConfig;
    //         this.regionDtoList = res.data.regionDtoList;
    //       }
    //     }
    //   });
    // },
    getParams() {
      return {
        rewardExpire: this.rewardExpire,
        regionDtoList: this.regionDtoList,
        useRewardLimit: this.useRewardLimit
      }
    },
    addRule() {
      this.dialogRuleVisible = true;
    },
    configBtn(row, type, index) {
      this.rowId = index;
      this.tableOperation = type;
      if (type == "del") {
        this.dialogDelVisible = true;
      } else {
        this.ruleForm.lower = row.lower;
        this.ruleForm.upper = row.upper;
        this.ruleForm.reward = row.reward;
        this.ruleForm.rewardLimit = row.rewardLimit;
        this.dialogRuleVisible = true;
      }
    },
    ruleDialogClosed() {
      this.rowId = "";
      this.tableOperation = "del";
      this.ruleForm = {
        lower: "",
        upper: "",
        reward: "",
        rewardLimit: "",
      };
      this.$refs["ruleForm"].resetFields();
    },
    // 弹框规则确认
    handleSuccess() {
      console.log(this.ruleForm);
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let ruleForm = this.ruleForm;
          console.log(ruleForm);
          if (Number(ruleForm.lower) > Number(ruleForm.upper)) {
            this.$message.error("起始值不能大于结束值");
            return;
          }
          if (Number(ruleForm.lower) == Number(ruleForm.upper)) {
            this.$message.error("起始值不能和结束值相等");
            return;
          }
          let params = {
            lower: ruleForm.lower,
            upper: ruleForm.upper,
          };
          if (this.regionDtoList.length && this.tableOperation != "edit") {
            let numArr = [];
            this.regionDtoList.forEach((item) => {
              numArr.push(item.lower);
              numArr.push(item.upper);
            });
            let iMin = Math.min(...numArr); //最小值
            let iMAX = Math.max(...numArr); //最大值
            if (ruleForm.upper != iMin && ruleForm.lower != iMAX) {
              this.$message.error("价位段不连续");
              return;
            }
            if (ruleForm.lower != iMAX && ruleForm.upper != iMin) {
              this.$message.error("价位段不连续");
              return;
            }
          }
          if (ruleForm.reward == 0) {
            this.$message.error("红包比例不能为0");
            return;
          }
          params.reward = ruleForm.reward;
          params.rewardLimit = ruleForm.rewardLimit;
          if (this.rowId.toString()) {
            this.regionDtoList.splice(this.rowId, 1, params);
          } else {
            this.regionDtoList.push(params);
          }
          this.dialogRuleVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSuccessDel() {
      this.regionDtoList.splice(this.rowId, 1);
      this.rowId = "";
      this.dialogDelVisible = false;
    },
    //提交
    save() {
      if (this.factorRate == "") {
        this.$message.error("商户估价系数不能为空");
        return;
      }
      if (this.factorRate > 5) {
        this.$message.error("商户估价系数不能大于5");
        return;
      }
      if (this.factorRate == 0) {
        this.$message.error("商户估价系数不能为0");
        return;
      }
      this.dialogSubmitVisible = true;
    },
    // 确认保存提示
    handleSuccessSave() {
      this.btnLoading = true;
      let params = {
        factorRate: this.factorRate,
        rewardExpire: this.rewardExpire,
        usePayConfig: this.usePayConfig,
        regionDtoList: this.regionDtoList,
      };
      _api
        .savePayconfig(params)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
          }
          this.btnLoading = false;
          this.dialogSubmitVisible = false;
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
    // 查看利润弹框
    seeProfit() {
      this.dialogProfitVisible = true;
    },
    rebateHandleCurrentChange(val) {
      this.rebatePage.pageNum = val;
    },
    redHandleCurrentChange(val) {
      this.redPacketPage.pageNum = val;
    },
    limitInput(value, name, type) {
      if (type == "this") {
        this[name] =
          ("" + value) // 第一步：转成字符串
            .replace(/[^\d^.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
            .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
            .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
            .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，	而且小数点后面只能有0到2位小数
      } else {
        this.ruleForm[name] =
          ("" + value) // 第一步：转成字符串
            .replace(/[^\d^.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
            .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
            .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
            .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，	而且小数点后面只能有0到2位小数
        if (this.ruleForm[name] > 100) {
          this.ruleForm[name] = 100;
        }
      }
    },
    formatNum(add, reduce, s, num) {
      let m = Math.pow(10, num); //num是10的次幂
      let res =
        s == "+" ? (add * m + reduce * m) / m : (add * m - reduce * m) / m;
      return Math.round(res * m) / m;
    },
    // 查看限时红包示例
    seeImg() {
      this.showViewer = true
    }
  },
};
</script>

<style lang="scss" scoped>
.GlobalTable {
  .line {
    height: 1px;
    background: #edeffd;
    margin-bottom: 20px;
  }
  .tip-color {
    color: #ff687b;
    font-size: 12px;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex-jb {
    display: flex;
    justify-content: space-between;
  }
  .flex-jc {
    display: flex;
    justify-content: center;
  }
  .module-title {
    font-size: 16px;
    color: #000000;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .set-title {
    font-weight: bold;
    color: #333333;
    font-size: 16px;
    height: 16px;
    padding-left: 10px;
    border-left: 3px solid #0981ff;
    margin-bottom: 10px;
  }
  .set-title-little {
    position: relative;
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .set-title-little::before {
    content: "";
    display: block;
    width: 64px;
    height: 6px;
    background: linear-gradient(
      to right,
      rgba(255, 175, 41, 0.61) 39%,
      rgba(255, 175, 41, 0) 100%
    );
    opacity: 0.65;
    border-radius: 3px;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  /deep/.el-input-group__append {
    border: 1px solid #0981ff;
    background: #0981ff;
    color: #ffffff;
  }
  .del-title {
    color: #ff8080;
    font-size: 12px;
    .sure_tip {
      margin-top: 15px;
      font-size: 16px;
      color: #333333;
    }
  }
  .factor-rate {
    width: 40px;
    margin-left: 5px;
  }
  /deep/.factor-rate .el-input__inner {
    padding: 0 5px;
    text-align: center;
  }
  /deep/.demo-ruleForm .el-form-item__content .el-input-group {
    vertical-align: middle;
  }
}
</style>
